export default __webpack_public_path__ + "static/media/video-dubbing.6f043132.svg";